const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const sentOnce = new Set();

const rid = () => Math.random().toString(36).slice(2) + Date.now().toString(36);

const getUid = () => {
  let id = localStorage.getItem("pl_uid") || localStorage.getItem("pl_sid");
  if (!id) id = rid();
  localStorage.setItem("pl_uid", id);
  return id;
};

const getSsid = () => {
  let id = sessionStorage.getItem("pl_ssid");
  if (!id) {
    id = rid();
    sessionStorage.setItem("pl_ssid", id);
  }
  return id;
};

const getSource = () => {
  let src = sessionStorage.getItem("pl_src");
  if (src) return src;
  const p = new URLSearchParams(window.location.search);
  src = p.get("utm_source");
  if (!src && document.referrer) {
    try {
      const h = new URL(document.referrer).hostname.replace(/^www\./, "");
      if (h && h !== window.location.hostname.replace(/^www\./, "")) src = h.split(".")[0];
    } catch {}
  }
  src = (src || "direct").toLowerCase().slice(0, 40);
  sessionStorage.setItem("pl_src", src);
  return src;
};

export const trackIds = () => {
  try {
    return { uid: getUid(), ssid: getSsid(), source: getSource() };
  } catch {
    return {};
  }
};

export const disableTracking = () => {
  try { localStorage.setItem("pl_no_track", "1"); } catch {}
};

// once=true: count at most one per page load (protects against re-render duplicates).
export function track(event, meta, { once = true } = {}) {
  try {
    if (localStorage.getItem("pl_no_track") === "1") return;
    if (once) {
      if (sentOnce.has(event)) return;
      sentOnce.add(event);
    }
    fetch(`${API}/events/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ event, ...trackIds(), host: window.location.host, meta: meta || undefined }),
      keepalive: true,
    }).catch(() => {});
  } catch {}
}
